export const StatusBadge = ({ status }) => {
  const statusColors = {
    // New simplified workflow
    'Submitted': 'text-yellow-400 bg-yellow-400/10 border-yellow-400/20',
    'Quoted': 'text-orange-400 bg-orange-400/10 border-orange-400/20',
    'Dispatched': 'text-blue-400 bg-blue-400/10 border-blue-400/20',
    'Picked Up': 'text-indigo-400 bg-indigo-400/10 border-indigo-400/20',
    'Delivered': 'text-purple-400 bg-purple-400/10 border-purple-400/20',
    'Returned': 'text-teal-400 bg-teal-400/10 border-teal-400/20',
    'Completed': 'text-green-400 bg-green-400/10 border-green-400/20',
    // Legacy statuses
    'Submitted – Pending DLT Approval': 'text-yellow-400 bg-yellow-400/10 border-yellow-400/20',
    'Pending Approval': 'text-yellow-400 bg-yellow-400/10 border-yellow-400/20',
    'Rate Requested': 'text-orange-400 bg-orange-400/10 border-orange-400/20',
    'Approved': 'text-green-400 bg-green-400/10 border-green-400/20',
    'Rejected': 'text-red-400 bg-red-400/10 border-red-400/20'
  };

  // Map legacy statuses to new workflow for display
  const displayStatus = (s) => {
    if (s === 'Submitted – Pending DLT Approval' || s === 'Pending Approval') return 'Submitted';
    if (s === 'Rate Requested') return 'Quoted';
    if (s === 'Approved') return 'Dispatched';
    return s;
  };

  return (
    <span className={`px-3 py-1 rounded-sm border text-xs font-bold uppercase tracking-wider ${statusColors[status] || statusColors['Submitted']}`}>
      {displayStatus(status)}
    </span>
  );
};
